import { render, staticRenderFns } from "./table-coupont.vue?vue&type=template&id=3df58791&scoped=true&"
import script from "./table-coupont.vue?vue&type=script&lang=js&"
export * from "./table-coupont.vue?vue&type=script&lang=js&"
import style0 from "./table-coupont.vue?vue&type=style&index=0&id=3df58791&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df58791",
  null
  
)

export default component.exports